/* @flow */
import apiRequest from 'lib/apiRequest';

const AppLinkActions = {
  sendLink(phoneNumber: string) {
    return apiRequest('/devices/sms/send_app_link', 'POST', {
      endpoint: phoneNumber,
    });
  },
};

export default AppLinkActions;



// WEBPACK FOOTER //
// ./src/actions/AppLinkActions.js